function handler(element, valueAccessor) {
  let num = parseFloat(ko.toJS(valueAccessor()));
  element.textContent = num.toLocaleString();
}

export default {
  init: handler,
  update: handler
};
